<template>
  <TopBar title="Which citizenship/residency type best describes you?" :step="step"/>
  <div class="step">
    <div v-for="(field, index) in fields" :key="field.value">
      <button class="btn-select" @click="toggleSelect(index)" :class="{ selected: field.value === selected }" v-html="field.title"></button>
    </div>
  </div>
  <BottomBar :step="step" :show-next="false"/>
</template>
<script>
import { mapState } from 'vuex'

import TopBar from '@/components/TopBar'
import BottomBar from '@/components/BottomBar'

export default {
  props: {
    step: {
      required: true
    }
  },
  components: {
    TopBar,
    BottomBar
  },
  computed: mapState({
    selected: state => state.formData.residency
  }),
  data () {
    return {
      fields: [
        {
          title: 'Australian citizen <br>(including dual citizens)',
          value: 'Citizen'
        },
        {
          title: 'Australian permanent <br>humanitarian visa holder',
          value: 'Humanitarian Visa'
        },
        {
          title: 'Australian permanent <br>resident',
          value: 'Permanent Resident'
        },
        {
          title: 'New Zealand citizen',
          value: 'New Zealand'
        },
        {
          title: 'Temporary visa holder',
          value: 'Temporary Visa'
        },
        {
          title: 'International or other',
          value: false
        }
      ]
    }
  },
  methods: {
    toggleSelect (index) {
      if (this.fields[index].value === false || this.fields[index].value === 'Temporary Visa') {
        document.location.href = '/international-students'
      }
      this.$store.commit('setFormData', { key: 'residency', value: this.fields[index].value })
      this.$router.push('/step/4')
    }
  }
}
</script>
<style lang="scss">
@import './../assets/scss/mixins';

.step-3 {
  .step {
    display: flex;
    flex-wrap: wrap;
    row-gap: 3px;

    > div {
      flex-basis: 100%;
      flex-grow: 0;
      display: flex;
      min-height: 98px;

      @include respond-above(lg) {
        min-height: 209px;
      }

      button {
        width: 100%;
      }

      @include respond-above(lg) {
        flex-basis: 33.33333%;
        //aspect-ratio: 1.63;
      }
    }
  }
}
</style>
